import { LazyMotion } from 'motion/react'

const loadAnimation = () => import('@/lib/motion/features').then((m) => m.domAnimation)
const loadMax = () => import('@/lib/motion/features').then((m) => m.domMax)

export const Motion = ({ children }: { children: React.ReactNode }) => (
  <LazyMotion features={loadAnimation}>{children}</LazyMotion>
)

export const MotionLayout = ({ children }: { children: React.ReactNode }) => (
  <LazyMotion features={loadMax}>{children}</LazyMotion>
)
